import React, { memo, useState } from 'react'

import { Icon } from '..'
import { util } from '../../../util'

const HoverButton = ({ endIcon, btnText, isRounded, startIcon, className, ...rest }) => {
    const [isHovered, setHovered] = useState(false)

    const hoverBtnClass = util.joinClasses(
        'hover-btn',
        isRounded && 'is-rounded',
        (!!startIcon || !!endIcon) && 'having-icons',
        className
    )

    const onMouseEnterHandler = () => setHovered(true)

    const onMouseLeaveHandler = () => setHovered(false)

    return (
        <div
            className={hoverBtnClass}
            onMouseEnter={onMouseEnterHandler}
            onMouseLeave={onMouseLeaveHandler}
            {...rest}
        >
            {startIcon && (
                <span className={'mt-1 mr-3'}>
                    <Icon renderIcon={endIcon} size={'xs'} />
                </span>
            )}
            <span className={`${isHovered ? 'show-btn' : 'hide-btn'} px-3`}>{btnText}</span>
            {endIcon && (
                <span>
                    <Icon
                        className={`${isHovered ? 'px-3' : ''} mt-1`}
                        renderIcon={endIcon}
                        size={'xs'}
                    />
                </span>
            )}
        </div>
    )
}

export default memo(HoverButton)
